import VerticalPage from "../components/VerticalPage";
import { usePageTitle } from "../hooks/usePageTitle";

const CONFIG = {
  verticalSlug: "lawn-care",
  eyebrow: "Built for Lawn Care & Landscaping",
  headline: "Win more lawn bids.",
  headlineHighlight: "Build a 5-star reputation.",
  sub: "CleanBid sends estimates via SMS before your competition calls back, follows up on every open bid automatically, and collects reviews at the end of every service — so you stay top of mind all season.",
  quoteCard: {
    service: "Weekly Lawn Maintenance",
    size: "1/3 acre",
    price: "$75",
  },
  problems: [
    {
      title: "Quote Speed Decides Jobs",
      body: "Lawn care is competitive. Customers compare 3 bids and go with whoever responds fastest. If you're slow, the grass grows and so does your competitor's client list.",
    },
    {
      title: "Recurring Revenue at Risk",
      body: "Seasonal customers forget to rebook. Without a follow-up system, you're rebuilding your route from scratch every spring instead of locking in recurring revenue.",
    },
    {
      title: "Missing Reviews",
      body: "Lawn care runs on neighborhood trust. Every job you complete without asking for a review is a missed chance to become the go-to in your area.",
    },
  ],
  features: [
    {
      badge: "SMS Estimating",
      headline: "Send a bid in 60 seconds — before your competitor calls back.",
      body: "Customers shopping lawn care want a fast answer. CleanBid lets you send a real estimate via SMS in under a minute, from anywhere. One tap to accept, job created automatically.",
    },
    {
      badge: "Follow-Up Automation",
      headline: "Never lose a bid to silence again.",
      body: "Not every customer books on the first quote. CleanBid follows up automatically on every open estimate — day 1, day 3, day 5 — so you close more without doing more.",
    },
    {
      badge: "Review Collection",
      headline: "Turn every lawn job into a Google review.",
      body: "At the end of every service, CleanBid sends a review request. No in-person ask. No forgetting. Just more 5-star ratings building your reputation in the neighborhood.",
    },
  ],
  testimonial: {
    quote: "It's the first piece of software that actually feels like it's on my side.",
    name: "Derek P.",
    role: "Lawn Care & Landscaping",
    img: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=60&h=60&fit=crop&crop=face",
  },
  ctaBadge: "Ready to close more lawn care jobs this season?",
  heroImage: {
    src: "https://cdn.searchlegends.com/kro-website/lawn-care.webp",
    alt: "Professional lawn care technician",
  },
};

export default function ForLawnCarePage() {
  usePageTitle("CleanBid for Lawn Care Businesses");
  return <VerticalPage config={CONFIG} />;
}
